import {FC} from 'react'
import {GameDetail} from '@app/components/game-player/types/game'
import TagContent from './tag'

interface Props {
  game: GameDetail
}

const Tags: FC<Props> = ({game}) => {
  const showTrendingTag = !game.isNew && game.isTrending
  return (
    <div className='absolute left-0 top-10'>
      {game.isNew && <TagContent text='NEW' />}
      {showTrendingTag && <TagContent text='TRENDING' />}
    </div>
  )
}

export default Tags
